import { util } from 'pevueglobal'
import { loadGmapApi } from '@/modules/googlemaps.js'
import Vue from 'vue'
const state = {
  pointsOfInterest: [],
  filters: [],
  config: {
    tblProfGroupGoogleApiKey: '',
    mapsloaded: false
  },
  poiInfo: [],
  poiNps: [],
  poiProf: [],
  poiProfMeta: [],
  poiInterface: {
    filtersVisible: true,
    infoVisible: false,
    profsVisible: false,
    leftButtonDisabled: false,
    rightButtonDisabled: false,
    poiselected: 0,
    profselected: 0
  },
  allspecs: [],
  serverFilterValues: []
}

// getters
const getters = {
  pointsOfInterest: state => state.pointsOfInterest,
  poiInfo: state => state.poiInfo,
  poiNps: state => state.poiNps,
  poiProf: state => state.poiProf,
  mapsloaded: state => state.config.mapsloaded,
  poiInterface: state => state.poiInterface,
  filters: state => state.filters,
  clientFilters: state => state.filters.filter(f => f.searchFieldServerSide === 0),
  serverFilters: state => state.filters.filter(f => f.searchFieldServerSide === 1),
  poiProfMeta: state => tblPersonID =>
    state.poiProfMeta.filter(pm => pm.tblPersonID === tblPersonID && pm.tblPersonInfoRequiredValueValue !== ''),
  serverFilterValues: state => state.serverFilterValues,
  tblProfGroupGoogleApiKey: state => state.config.tblProfGroupGoogleApiKey,
  allspecs: state => state.allspecs
}

// actions
const actions = {
  PEapi_PointsOfInterest: async ({ commit }) => {
    commit('startLoading', { showmessage: false, disablepage: false }, { root: true })
    // haal eerst pagina data op en daarna pas tabel en graphcontrol
    const poi = await util.getDataApi('public/PEapi_SKF_PointsOfInterest')
    await loadGmapApi({ key: poi.ds.data1[0].tblProfGroupGoogleApiKey })
    commit('SETPEapi_PointsOfInterest', poi)
    commit('stopLoading', null, { root: true })
  },
  PEapi_PointsOfInterest_Info: async ({ commit }, { poiIDs }) => {
    commit('startLoading', { showmessage: false, disablepage: false }, { root: true })
    // haal eerst pagina data op en daarna pas tabel en graphcontrol
    const poiInfo = await util.getDataApi('public/PEapi_SKF_PointsOfInterest_Info', { poiIDs: poiIDs })
    commit('SETPEapi_PointsOfInterest_Info', poiInfo)
    commit('stopLoading', null, { root: true })
  },
  PEapi_PointsOfInterest_Profs: async ({ commit }, { poiID }) => {
    commit('startLoading', { showmessage: false, disablepage: false }, { root: true })
    // haal eerst pagina data op en daarna pas tabel en graphcontrol
    const poiProfs = await util.getDataApi('public/PEapi_SKF_PointsOfInterest_Profs', { poiID: poiID })
    commit('SETPEapi_PointsOfInterest_Profs', poiProfs)
    commit('stopLoading', null, { root: true })
  },

  PEapi_PointsOfInterest_Search: async ({ commit }, { filters }) => {
    commit('startLoading', { showmessage: false, disablepage: false }, { root: true })
    // haal eerst pagina data op en daarna pas tabel en graphcontrol
    const poi = await util.getDataApi('public/PEapi_SKF_PointsOfInterest_Search', { filters: filters })
    commit('SETPEapi_PointsOfInterestSearch', poi)
    commit('stopLoading', null, { root: true })
  }
}

// mutations
const mutations = {
  resetFilters(state) {
    state.serverFilterValues = []
  },
  leftButtonDisabled(state, Disabled) {
    state.poiInterface.leftButtonDisabled = Disabled
  },
  rightButtonDisabled(state, Disabled) {
    state.poiInterface.rightButtonDisabled = Disabled
  },
  poiSelectedIncrease(state) {
    state.poiInterface.poiselected++
  },
  poiSelectedDecrease(state) {
    state.poiInterface.poiselected--
  },
  togglefiltersVisible(state, visible) {
    state.poiInterface.filtersVisible = visible
    state.poiInterface.infoVisible = false
    state.poiInterface.profsVisible = false
  },
  toggleInfoVisible(state, visible) {
    state.poiInterface.poiselected = 0
    state.poiInterface.infoVisible = visible
    state.poiInterface.leftButtonDisabled = true
    state.poiInterface.rightButtonDisabled = false
  },
  toggleProfsVisible(state, visible) {
    state.poiInterface.profsVisible = visible
  },
  SETGooglemapsLoaded(state) {
    state.config.mapsloaded = true
  },
  SETPEapi_PointsOfInterest(state, poi) {
    state.pointsOfInterest = poi.ds.data0
    state.config.tblProfGroupGoogleApiKey = poi.ds.data1[0].tblProfGroupGoogleApiKey
    state.filters = poi.ds.data2
    // set search waarde voor slider type
    state.filters.forEach(f => {
      if (f.searchFieldFieldType === 3) {
        Vue.set(f, 'searchFieldvalue', f.searchFieldMinValue)
      } else {
        Vue.set(f, 'searchFieldvalue', '')
      }
    })

    state.poiInterface.profsVisible = false

    poi.ds.data3.forEach(spec => {
      let newspec = { value: spec.tblPersonInfoRequiredPossibleValueID, text: spec.posValueName }
      state.allspecs.push(newspec)
    })
  },

  SETPEapi_PointsOfInterestSearch(state, poi) {
    state.serverFilterValues = poi.ds.data0
  },
  SETPEapi_PointsOfInterest_Info(state, poiInfo) {
    poiInfo.ds.data0.forEach(I => {
      I.npsdata = {
        data: null
      }
      I.npsdata.data = poiInfo.ds.data1.filter(S => S.tblPointOfInterestID === I.tblPointOfInterestID)
    })
    state.poiInfo = poiInfo.ds.data0
    state.poiInterface.profsVisible = false
  },
  SETPEapi_PointsOfInterest_Profs(state, poiProfs) {
    state.poiProf = poiProfs.ds.data0
    state.poiProfMeta = poiProfs.ds.data1
    state.poiInterface.profsVisible = true
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
